<!--
 * @Author: cryi.liu
 * @Date: 2020-05-06 15:10:15
 * @LastEditTime: 2020-06-14 11:00:24
 * @Description: 数据表格
 -->
<template>
  <i-table
    border
    :columns="columns"
    :data="data"
    @on-sort-change="tableSortChangeHandler" />
</template>

<script>
export default {
  name: 'DataTable',
  props: {
    paperId: { type: [Number, String], required: true },
    data: { type: Array, required: true },
  },
  data() {
    return {
      columns: [
        {
          title: '姓名',
          key: 'name',
        },
        {
          title: '账号',
          key: 'userId',
          align: 'center',
        },
        {
          title: '身份明细',
          key: 'userTypeName',
          align: 'center',
        },
        {
          title: '大区',
          key: 'branchName',
          align: 'center',
        },
        {
          title: '全国排名',
          key: 'rank',
          align: 'center',
        },
        {
          title: '分数',
          key: 'score',
          align: 'center',
          sortable: 'custom',
        },
        {
          title: '操作',
          key: 'action',
          width: 150,
          align: 'center',
          render: (h, params) => h('div', [
            // h('a', {
            //   style: {
            //     marginRight: '5px',
            //   },
            //   on: {
            //     click: this.deletePersonAnswerDetail(params.row),
            //   },
            // }, '删除'),
            h('a', {
              on: {
                click: this.routeToAnswerDetail(params.row),
              },
            }, '答题详情'),
          ]),
        },
      ],
    };
  },
  methods: {
    /**
     * 表格排序
     */
    tableSortChangeHandler({ key, order }) {
      if (key === 'score') {
        this.tableSortOfScoreHandler(order);
      }
    },
    /**
     * 表格按照分数排序处理函数
     */
    tableSortOfScoreHandler(order) {
      let realOrder = null;
      if (order === 'asc') {
        realOrder = 0;
      } else if (order === 'desc') {
        realOrder = 1;
      }

      this.$emit('set-order', realOrder);
    },
    /**
     * 删除考生答题详情
     */
    deletePersonAnswerDetail({ userId }) {
      return () => {
        this.requestDeletePersonAnswerDetailAndSetting(userId);
      };
    },
    /**
     * 路由跳转答题详情处理函数
     */
    routeToAnswerDetail({ userId }) {
      return () => {
        this.$router.push({
          path: '/answer/detail',
          query: {
            paperId: this.paperId,
            userCode: userId,
          },
        });
      };
    },
    /**
     * 请求删除考生答题详情并设置
     */
    requestDeletePersonAnswerDetailAndSetting(userId) {
      this.requestDeletePersonAnswerDetail(userId)
        .then((result) => {
          if (result.message === '成功') {
            this.$emit('repull-list');
          } else {
            alert('删除失败');
          }
        })
        .catch(() => {
          alert('删除失败');
        });
    },
    /**
     * 请求删除考生答题详情
     */
    requestDeletePersonAnswerDetail(userId) {
      const params = {
        paperId: this.paperId,
        userId,
      };

      return new Promise(async (resolve, reject) => {
        const result = await this.$http.examcenter.paperDeleteByPerson(params);

        if (result.success) {
          resolve(result.data);
        } else {
          reject(result);
        }
      });
    },
  },
};
</script>
